/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import { baseUrl } from '@/model/storage/index'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false,
  },

  name: {
    displayName: 'unitName',
  },

  nextLevelFactor: {
    type: IKDataEntity.Types.Integer,
  },

  note: {},
}
const config = {
  add: async function (item) {
    return (await hillo.jsonPost(baseUrl + 'resourceUnit/create', item, {
      showLoading: true,
    })).data
  },
  edit: function (item) {
    delete item.__parsed
    return hillo.jsonPost(baseUrl + 'resourceUnit/edit/' + item.id, item, {
      showLoading: true,
    })
  },
  remove: function (id) {
    return hillo.post(baseUrl + 'resourceUnit/delete/' + id,
      { id: id },
    )
  },
  load: async function () {
    return (await hillo.jsonPost(baseUrl + 'resourceUnit/getList', {}))
      .data
  },
}

export default IKDataEntity.ModelFactory(entity, config)
